export const msalErrorMessage_AADB2C90077 = 'AADB2C90077';
export const msalErrorMessage_AADB2C90118 = 'AADB2C90118';
export const useRedirectFlow = true;
